import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export {
  ListingTableCell as TableCellElement,
  PatientName,
} from "../common/ListingTable.style";

export const PatientNameStatus = styled(Box)`
  display: flex;
  align-items: center;
`;

export const FailedResponseContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const FailedResponse = styled(Typography)`
  color: red;
`;

export const InProgressResponse = styled(Typography)`
  color: grey;
`;

export const CompletedResponse = styled(Typography)`
  color: green;
`;

export const FailedIconIndicator = styled(InfoIcon)`
  color: red;
`;
